import { useContext } from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

import FileCarousel from '../carousel/FileCarousel';

import { ModalContext } from './Modal';

export default function FileCarouselModal({ files, objectID, objectTypeID, portalID }) {
    // Get the changeModalName function from the ModalContext
    const { state } = useLocation();
    const { changeModalName } = useContext(ModalContext);

    // See if state was passed in with the url change, if so, get the index of the file in the files array
    const targetIndex = state?.fileID ? files.files.findIndex(file => file.file.fileID === state.fileID) : 0;

    // when onFileChange fires, get the title and change the modal name
    const onFileChange = file => {
        changeModalName(file?.file?.title ?? '');
    };

    return <FileCarousel files={files} objectID={objectID} objectTypeID={objectTypeID} portalID={portalID} onFileChange={onFileChange} currentIndex={targetIndex} />;
}
